import client from '../../utils/api'
import { createSlice } from '@reduxjs/toolkit'
import { createApiAction } from '../../utils/redux-tool'

const name = 'assetNeedAttention'
const initialState = {
  needsAttention: null,
  recentlyAdded: null,
  pendingAcceptance: null,
  inactiveAssigned: null,
  loading: false,
}

export const search = createApiAction('asset/need-attention/search', client.search('/api/asset/need-attention'))
export const saveAssetDraft = createApiAction('asset/need-attention/save-draft', client.save('/api/asset/draft'))
export const deleteAssetDraft = createApiAction('asset/need-attention/delete-draft', client.destroy('/api/asset/draft'))
export const acceptAssetTransfer = createApiAction('asset/need-attention/accept-transfer', client.update('/api/asset/transfer/:id'))
export const rejectAssetTransfer = createApiAction('asset/need-attention/reject-transfer', client.destroy('/api/asset/transfer/:id'))

const needAttentionSlice = createSlice({
  name,
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(search.pending, state => {
        state.loading = true
      })
      .addCase(search.fulfilled, (state, action) => {
        state.needsAttention = action.payload
        state.recentlyAdded = action.payload['asset-drafts'] || []
        state.pendingAcceptance = action.payload['asset-transfers'] || []
        state.inactiveAssigned = action.payload['inactive'] || []
        state.loading = false
      })
      .addCase(saveAssetDraft.fulfilled, (state, action) => {
        const id = action.payload.assetDraft.id
        state.recentlyAdded = (state.recentlyAdded).filter(item => item.id !== id)
      })
      .addCase(deleteAssetDraft.fulfilled, (state, action) => {
        const { ids, id } = action.meta.arg
        const toDelete = new Set(ids ?? [id])
        state.recentlyAdded = (state.recentlyAdded || []).filter(item => !toDelete.has(item.id))
      })
      .addCase(acceptAssetTransfer.fulfilled, (state, action) => {
        const id = action.meta.arg.id
        state.pendingAcceptance = (state.pendingAcceptance || []).filter(item => item.id !== id)
        state.needsAttention = null
      })
      .addCase(rejectAssetTransfer.fulfilled, (state, action) => {
        const id = action.meta.arg.id
        state.pendingAcceptance = (state.pendingAcceptance || []).filter(item => item.id !== id)
        state.needsAttention = null
      })
  },
})

export default needAttentionSlice.reducer
